import { useEffect, useState } from 'react';
import axiosClient from '../../../axios-client';

const Footer = () => {
    const [loading, setLoading] = useState();
    const [links, setLinks] = useState();


    useEffect(() => {
        if (!links) {
            fetchData()
        }
    }, [links]);

    const fetchData = () => {
        axiosClient.get('/pages')
            .then(({ data }) => {
                setLinks(data.data)
            })
            .catch(err => {
                const response = err.response.data;
                if (response) {
                    const errorMessages = Object.values(response)
                        .map((errorArray) => errorArray[0]);
                    setMsgError(errorMessages);
                    setErrors(response);
                } else {
                    console.error('Unexpected error response format:', response);
                }
            })
    }





    return (
        <div className='mt-auto'>
            <div className='container-fluid footer mt-5'>
                <div className='row align-items-center'>
                    <div className='col-md-3 order-md-1'>
                        <p className='py-2 m-0 txt-copiright text-center'>Copyright 2023, all right reserved</p>
                    </div>
                    <div className='col-md-6 text-center order-first order-md-2'>
                        {links && links.map((link, index) => ( // Changed variable name from links to link
                            <a
                                key={link.id || index} // Use link.id as the key if available, otherwise fallback to index
                                className='py-2 me-2 ms-2 text-white'
                                target={`${link.redirect_to ? '_blank' : ''}`}
                                href={`${link.redirect_to ? link.redirect_to : link.slug}`}
                            >
                                {link.title}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer